var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"chit_header"},[_c('img',{attrs:{"src":_vm.webUrl+'assets/jobeekerImages/Group 16@2x.png'}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }